import _ from "lodash";
import apiCore from "services/apiCore";
import EvaluationModel from "models/composer/Evaluation";

//Construct an evaluation model(s) from (each) object returned
function constructEvaluation(evaluationData) {
    return new EvaluationModel(evaluationData);
}

function constructEvaluationList(evaluationDataList) {
    return _.map(evaluationDataList, constructEvaluation);
}

//=====================
// Module Construction
//=====================
const module = {
    EXPAND_PUBLISH_HISTORY_FLAG: "publishHistory", //passing expand=publishHistory on a get.page will include publish history metadata
    get: {},
    post: {},
    put: {},
    del: {},
};
// GET
module.get.page = function (data) {
    const endpoint = "/quality/forms";
    data = _.assign(
        {
            pageSize: 100,
            pageNumber: 1,
            filter: "",
        },
        data
    );

    return apiCore.v2.get(endpoint, data).then(function (response) {
        // add convenience method to strip off paging info
        response.asList = function () {
            return constructEvaluationList(response.entities);
        };
        return response;
    });
};
module.get.byId = function (evalId) {
    const endpoint = "/quality/forms/" + evalId;
    return apiCore.v2.get(endpoint).then(function (response) {
        return constructEvaluation(response);
    });
};
module.get.published = {};
module.get.published.page = function (data) {
    const endpoint = "/quality/publishedForms";
    data = _.assign(
        {
            pageSize: 100,
            pageNumber: 1,
            filter: "",
        },
        data
    );

    return apiCore.v2.get(endpoint, data).then(function (response) {
        // add convenience method to strip off paging info
        response.asList = function () {
            return constructEvaluationList(response.entities);
        };
        return response;
    });
};
module.get.published.byId = function (evalId) {
    const endpoint = "/quality/publishedForms/" + evalId;

    return apiCore.v2.get(endpoint).then(function (response) {
        return constructEvaluation(response);
    });
};
module.get.versions = {};
module.get.versions.byId = function (evalId) {
    const endpoint = "/quality/forms/" + evalId + "/versions";
    return apiCore.v2.get(endpoint).then(function (response) {
        return response;
    });
};
// POST
module.post.create = function (data) {
    const endpoint = "/quality/forms";
    return apiCore.v2.post(endpoint, data);
};
module.post.publish = function (evalId) {
    const endpoint = "/quality/publishedForms";
    const data = {
        id: evalId,
    };
    return apiCore.v2.post(endpoint, data);
};
// PUT
module.put.update = function (evalId, unwrappedEvaluationModel) {
    const endpoint = "/quality/forms/" + evalId;
    const data = unwrappedEvaluationModel;

    return apiCore.v2.put(endpoint, data);
};
// DELETE
module.del.instance = function (evalId) {
    const endpoint = "/quality/forms/" + evalId;
    return apiCore.v2.del(endpoint);
};

export default module;
